import { FC } from 'react';
import IconSvg from './assets/avatars/customer-avatar-resident.svg';

interface IconProps {
  width?: string | number;
  height?: string | number;
}

const Icon: FC<IconProps> = ({ width, height }) => (
  <img alt="CustomerAvatarResident" src={IconSvg} width={width} height={height} />
);

export default Icon;
